export default __webpack_public_path__ + "static/gouttes-d1bb82d937f2fac5edb03ef4d385747a.jpg";